import React from 'react';
import Icon from '../../../components/AppIcon';

const StatusTimeline = ({ order, statusHistory }) => {
  const statusSteps = [
    { key: 'NEW', label: 'Neu', icon: 'Plus' },
    { key: 'IN_REVIEW', label: 'In Prüfung', icon: 'Eye' },
    { key: 'ASSIGNED', label: 'Zugewiesen', icon: 'UserCheck' },
    { key: 'IN_PROGRESS', label: 'In Bearbeitung', icon: 'Wrench' },
    { key: 'DONE', label: 'Abgeschlossen', icon: 'CheckCircle' },
    { key: 'INVOICED', label: 'Abgerechnet', icon: 'FileText' }
  ];

  const getStepStatus = (stepKey) => {
    const currentIndex = statusSteps?.findIndex(step => step?.key === order?.status);
    const stepIndex = statusSteps?.findIndex(step => step?.key === stepKey);
    
    if (order?.status === 'CANCELLED') {
      return stepIndex === 0 ? 'completed' : 'cancelled';
    }
    
    if (stepIndex < currentIndex) return 'completed';
    if (stepIndex === currentIndex) return 'current';
    return 'pending';
  };

  const getStepDate = (stepKey) => {
    const historyItem = statusHistory?.find(item => item?.status === stepKey);
    return historyItem ? new Date(historyItem.timestamp)?.toLocaleDateString('de-DE') : null;
  };

  const getStepClasses = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-success text-success-foreground border-success';
      case 'current':
        return 'bg-primary text-primary-foreground border-primary';
      case 'cancelled':
        return 'bg-error text-error-foreground border-error';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  const getConnectorClasses = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-success';
      case 'current':
        return 'bg-gradient-to-r from-success to-primary';
      case 'cancelled':
        return 'bg-error';
      default:
        return 'bg-border';
    }
  };

  if (order?.status === 'CANCELLED') {
    return (
      <div className="bg-card rounded-lg border border-border p-6 mb-6">
        <h3 className="text-lg font-semibold text-text-primary mb-4">Status</h3>
        <div className="flex items-center gap-3 p-4 bg-red-50 border border-red-200 rounded-lg">
          <div className="w-10 h-10 rounded-full bg-error text-error-foreground flex items-center justify-center">
            <Icon name="X" size={20} />
          </div>
          <div>
            <div className="font-medium text-error">Auftrag storniert</div>
            <div className="text-sm text-text-secondary">
              Storniert am: {new Date(order.updatedAt)?.toLocaleDateString('de-DE')}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border p-6 mb-6">
      <h3 className="text-lg font-semibold text-text-primary mb-6">Bearbeitungsstatus</h3>
      <div className="relative">
        {statusSteps?.map((step, index) => {
          const stepStatus = getStepStatus(step?.key);
          const stepDate = getStepDate(step?.key);
          const isLast = index === statusSteps?.length - 1;
          
          return (
            <div key={step?.key} className="relative flex items-center">
              {/* Connector Line */}
              {!isLast && (
                <div 
                  className={`absolute left-5 top-12 w-0.5 h-16 ${getConnectorClasses(stepStatus)}`}
                />
              )}
              {/* Step Circle */}
              <div className={`relative z-10 w-10 h-10 rounded-full border-2 flex items-center justify-center ${getStepClasses(stepStatus)}`}>
                <Icon name={step?.icon} size={18} />
              </div>
              {/* Step Content */}
              <div className="ml-4 pb-8">
                <div className="font-medium text-text-primary">{step?.label}</div>
                {stepDate && (
                  <div className="text-sm text-text-secondary mt-1">{stepDate}</div>
                )}
                {stepStatus === 'current' && (
                  <div className="text-sm text-primary mt-1">Aktueller Status</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StatusTimeline;